import { useOrderSearchForm } from '@euler/app/flows/search/context';
import { FormGroup } from '@euler/components/form';
import { Input } from '@euler/components/form/Input';
import { memo } from 'react';

export const CustomerPhoneField = memo(() => {
  const { form } = useOrderSearchForm();
  return (
    <FormGroup label="车主电话">
      <Input
        value={form.customerPhone.value ?? ''}
        placeholder="按车主电话搜索"
        clearButtonMode="always"
        onChangeText={form.customerPhone.update}
      />
    </FormGroup>
  );
});
